module.exports = __webpack_public_path__ + "img/information-AS63199.a7ed0633.jpg";